import React, { useContext } from 'react';
import { number, func, string } from 'prop-types';
import useStyles from 'hooks/useStyles';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import ApplicationContext from 'components/ApplicationContext';

import Star from 'components/Star';
import { DEFAULT_RATING_SCORE } from 'routes/course/CourseLearning/constants';
import { START_COMMENT_KEYS } from '../../constants';

import styles from './Scorer.scss';

const Scorer = ({ className, score, onScore }) => {
  useStyles(styles);
  const { t } = useTranslation(['rating']);

  const {
    screenWidth: { isMobile },
  } = useContext(ApplicationContext);

  const isScored = Boolean(score);
  const svgSize = isMobile || isScored ? 32 : 40;

  const renderStars = (value, index) => {
    return (
      <span
        key={value}
        className={cx(styles.wrapper, {
          [styles.selected]: value === score,
        })}
        onClick={() => onScore(value)}
      >
        <Star className={styles.star} key={value} svgSize={svgSize} />
        <h6 className={styles.comment}>
          {t(`common.starComments.${START_COMMENT_KEYS[index]}`)}
        </h6>
      </span>
    );
  };

  return (
    <div
      className={cx(styles.root, className, {
        [styles.scored]: isScored,
      })}
    >
      {DEFAULT_RATING_SCORE.map(renderStars)}
    </div>
  );
};

Scorer.propTypes = {
  score: number.isRequired,
  onScore: func.isRequired,
  className: string,
};

Scorer.defaultProps = {
  className: '',
};

export default Scorer;
